import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Checkbox,
  Typography,
  Button,
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import { ExpandMore } from '@material-ui/icons'
import React, { useState } from 'react'
/**
 * Because this expansion panel is very limited in width, we are removing the default padding.
 * This should not be a pattern followed when there is sufficient real estate available.
 */

const useStyles = makeStyles(theme => ({
  details: {
    padding: '0px',
  },
  root: {
    '&:before': {
      display: 'none',
    },
  },
  summary: {
    padding: '0px',
  },
}))

const CuisinePreference = ({
  cuisineType,
  updateProfileAttributesStart,
  additionalAttributes,
  isLoadingCuisinePreference,
  isUpdatingCuisinePreference,
}) => {
  const classes = useStyles()
  const [chosenCuisines, setChosenCuisines] = useState(additionalAttributes.storeTypes ?? [])
  const handleChange = value => {
    chosenCuisines.includes(value)
      ? setChosenCuisines(chosenCuisines.filter(v => v !== value))
      : setChosenCuisines([...chosenCuisines, value])
  }

  const isChecked = checkBox => {
    return chosenCuisines.includes(checkBox)
  }

  return (
    <ExpansionPanel
      className={classes.root}
      defaultExpanded={cuisineType?.preferences?.length < 3}
      elevation={0}
      key={'Food Types'}
      square
    >
      <ExpansionPanelSummary
        className={classes.summary}
        expandIcon={<ExpandMore color="primary" />}
      >
        <Typography variant="h6">Food Types</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        <Grid container spacing={3}>
          {cuisineType?.map(pref => (
            <Grid container item key={pref?.label}>
              <Grid item xs={9}>
                <Typography variant="subtitle2">{pref.label}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  color="primary"
                  checked={isChecked(pref.value)}
                  inputProps={{ 'aria-label': `${pref.label} preference checkbox` }}
                  name={pref.value.toString()}
                  onChange={() => handleChange(pref.value)}
                  value={pref.label}
                />
              </Grid>
            </Grid>
          ))}
          <Button
            color="primary"
            variant="contained"
            role="button-submit"
            disabled={isUpdatingCuisinePreference || isLoadingCuisinePreference}
            onClick={() => updateProfileAttributesStart({ storeTypes: chosenCuisines })}
          >
            Update
          </Button>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default CuisinePreference
